import React, { useMemo } from 'react';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';
import { GridColDef } from '@mui/x-data-grid-pro';

import { IRouterProps } from '@interfaces/App.interface';
import { IConfigComponent } from '@ts/ui-models';
import { generateGlobalColumns, generateBasicColumn, IDataGridConfig } from '@ts/storybook';

interface IHSCodeProps extends IRouterProps {
  configComponent?: IConfigComponent;
  inheritedProps?: any;
}

export const defaultConfigComponent: IConfigComponent = {
  componentId: 'hsCode',
  aclId: 'hsCode',
  //entity: 'hsCode',
  fetchURL: '/api/hscode',
};

const HSCode = (props: IHSCodeProps) => {
  const { configComponent = defaultConfigComponent, inheritedProps } = props;
  const config: IDataGridConfig = {
    columnVisibilityModel: { id: false },
  };
  const getColumns = useMemo((): GridColDef<any>[] => {
    const globalCells = generateGlobalColumns({ ...props, configComponent });
    return [
      globalCells.id(),
      globalCells.name(),
      generateBasicColumn({ field: 'code', headerName: 'Code' }, { field: 'logicalId' }),
      generateBasicColumn({ field: 'description', headerName: 'Description' }, { field: 'name' }),
    ];
  }, [props, configComponent]);
  return (
    <WrapperDataGrid
      configComponent={configComponent}
      dataGridConfig={config}
      columns={getColumns}
      //Extra data
      inheritedProps={inheritedProps}
    />
  );
};

export default HSCode;
